import { createSelector } from 'reselect';
import { ToolbarList, ToolbarListType } from '../toolbarTypes';
import { CurrentToolbarReducerState } from '../currentToolbarReducer';

export const selectCurrentToolbarState = (state: any): CurrentToolbarReducerState =>
    state.getIn(['app', 'currentToolbar']);

const selectCurrentToolbar = createSelector(selectCurrentToolbarState, (toolbarState): ToolbarList | undefined => {
    if (!toolbarState) return undefined;

    const { toolbars, focusIndex } = toolbarState;
    return toolbars[focusIndex];
});

export const selectCurrentToolbarType = createSelector(
    selectCurrentToolbar,
    (currentToolbar): ToolbarListType | undefined => currentToolbar?.type,
);

export const selectIsCurrentToolbarType = (type: ToolbarListType) =>
    createSelector(selectCurrentToolbarType, (currentToolbarType) => currentToolbarType === type);

export const selectIsCurrentToolbarTypeCreateElement = selectIsCurrentToolbarType(ToolbarListType.CREATE_ELEMENT);
export const selectIsCurrentToolbarTypeMobileTabs = selectIsCurrentToolbarType(ToolbarListType.MOBILE_TABS);
